<template>
  <div class="cell-wrapper" @click="$emit('click')">
    <div class="cell-title">
      <img :src="group.avatar" alt>
      <span :data-id="group.groupID">{{group.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "cell-cell",
  data() {
    return {
      groupAvatar: 'http://148.70.221.198/pc//image/cl_group_avatar.png'
    }
  },
  props: {
    group: Object,
  }
};
</script>
<style scoped>
.cell-wrapper .cell-title {
  margin: 7px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}

.cell-wrapper:hover span {
  color: #409EFF;
}

.cell-title img {
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 0.6rem;
  border-radius: 50%;
  object-fit: cover;
}
</style>